import { parse } from "tldts";

//codsms = default - section, codsmsi = multi schools - school instead of section
export const getUrlData = () => {
  const subdomain = parse(window.location.origin).subdomain;
  let url = "";
  let appType = "";
  let assessment = {
    resultTemplates: [
      {
        title: "default",
        template: "template-1",
      },
    ],
    resulttemp: "default",
    number: 3,
    labels: ["C.A 1", "C.A 2", "C.A 3", "Exam"],
    inputLabel: {
      subject: "Subject",
      first: "C.A 1",
      second: "C.A 2",
      third: "C.A 3",
      cw: "C.W",
      hw: "H.W",
      exam: "Exam",
      total: "Total",
      grade: "Grade",
      comment: "Comment",
    },
    resultLabel: {
      subject: "Subject",
      first: "C.A 1",
      second: "C.A 2",
      third: "C.A 3",
      exam: "Exam",
      total: "Total",
      grade: "Grade",
      comment: "Remark",
    },
  };
  let cas = 2;
  switch (subdomain) {
    case "focusstaff":
      appType = "codsms";
      assessment = {
        resulttemp: "focus",
        resultTemplates: [
          {
            title: "Result Template",
            template: "focus",
          },
        ],
      };
      url = "https://pkcwunovj6.codsms.com/vn";
      break;
    // amnah specials school
    case "amnahssstaff":
      appType = "codsms";
      assessment = {
        resultTemplates: [
          {
            title: "Secondary Template",
            template: "amnah",
          },
          {
            title: "Primary Template",
            template: "amnahPM",
          },
        ],
      };
      url = "https://nrc3nf5gi.codsms.com/vn";
      break;
    //KD Public schools
    case "kdpublicschoolsstaffs":
      appType = "codsms";
      assessment = {
        resultTemplates: [
          {
            title: "Queen Amina",
            template: "queen-amina",
          },

        ],
      };
      url = "https://yfUZggu.codsms.com/vn";
      break;
    // Almajmau
    case "almajmaulstaff":
      url = "https://jk8m1z4fit.codsms.com/vn";
      appType = "codsms";
      assessment = {
        resulttemp: "almajmaul",
        resultTemplates: [
          {
            title: "English Secondary Template",
            template: "almajmaulSecondary",
          },
          {
            title: "English Primary Template",
            template: "almajmaulPrimary",
          },
          {
            title: "Arabic Template",
            template: "AlmaTahfiz",
          },
        ],
      };
      break;
    case "jmsstaff":
      appType = "codsms";
      assessment.resulttemp = "jms";
      assessment.number = 3;
      url = "https://6lbtsw8k.codsms.com/vn";
      break;
    // wanda school
    case "waandastaff":
      appType = "codsms";
      assessment = {
        sessionalTemplates: [
          {
            title: "Waanda Primary Sessional",
            template: "waanda-sessional-p",
          },
          {
            title: "Waanda Secondary Sessional",
            template: "waanda-sessional-s",
          },

        ],
        resultTemplates: [
          {
            title: "Secondary Template",
            template: "waanda",
          },
          {
            title: "Primary Template",
            template: "waandaHD",
          },
        ],
      };
      url = "https://4tiyX0W3.codsms.com/vn";
      break;
    // usara school
    case "usraastaff":
      appType = "codsms";
      assessment = {
        sessionalTemplates: [
          {
            title: "Usra Secondary Sessional",
            template: "UsraSessional",
          },
          {
            title: "Usra Primary Sessional",
            template: "UsraPrimarySessional",
          },
        ],
        resultTemplates: [
          {
            title: "Secondary Template",
            template: "usra",
          },
          {
            title: "Primary Template",
            template: "usraPrimary",
          },
          {
            title: "Thafeez Template",
            template: "usraTafize",
          },
        ],
        resulttemp: "usra",
      };
      url = "https://iku8byo9.codsms.com/vn";
      break;
    // misbahul
    case "misstaff":
      appType = "codsms";
      assessment = {
        resulttemp: "amnah",
        resultTemplates: [
          {
            title: "Secondary Template",
            template: "misbahu",
          },
          {
            title: "Primary Template",
            template: "misbahuPrimary",
          },
        ],
      };
      url = "https://pult9js47.codsms.com/vn";
      break;
    // Kad-british school
    case "kadbsstaff":
      appType = "codsms";
      assessment = {
        resultTemplates: [
          {
            title: "Template 1",
            template: "kadBritishS",
          },
          {
            title: "Template 2",
            template: "kadBritishN",
          },
          {
            title: "Template 3",
            template: "template-1",
          },
        ],
      };
      url = "https://ywoql0lytu.codsms.com/vn";
      break;
    default:
      appType = "codsms";
      assessment = {
        sessionalTemplates: [
          {
            title: "Usra Secondary Sessional",
            template: "UsraSessional",
          },
          {
            title: "Usra Primary Sessional",
            template: "UsraPrimarySessional",
          },
          {
            title: "Waanda Primary Sessional",
            template: "waanda-sessional-p",
          },
          {
            title: "Waanda Secondary Sessional",
            template: "waanda-sessional-s",
          },

        ],
        resultTemplates: [
          {
            title: "Usra Secondary Template",
            template: "usra",
          },
          {
            title: "Usra Primary Template",
            template: "usraPrimary",
          },
          {
            title: "Usra Thafeez Template",
            template: "usraTafize",
          },
          {
            title: "Secondary Template",
            template: "waanda",
          },
          {
            title: "Primary Template",
            template: "waandaHD",
          }, {
            title: "Waanda Secondary Template",
            template: "waanda",
          },
          {
            title: "Waanda primary Template",
            template: "waandaHD",
          },
          {
            title: "Queen Amina",
            template: "queen-amina",
          },
        ],
      };
      // url = "https://4tiyX0W3.codsms.com/vn";
      url = "https://iku8byo9.codsms.com/vn";
      // url = "https://ilua8s8k.codsms.com/vn";
      // url = "https://pult9js47.codsms.com/vn";
      break;
  }
  return { url, subdomain, appType, assessment, cas };
};
